import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { showToast } from '@/lib/toast';

interface ValidateTrimParams {
  year: number;
  make: string;
  model: string;
  trim: string;
}

export const useValidateTrim = (): UseMutationResult<
  { Year: number; Make: string; Model: string; Trim: string },
  Error,
  ValidateTrimParams
> => {
  return useMutation({
    mutationFn: async ({ year, make, model, trim }: ValidateTrimParams) => {
      const response = await fetch(
        `/api/compare/getVehicleStylesData/?year=${year}&make=${make}&model=${model}&trim=${encodeURIComponent(trim)}`,
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) {
        throw new Error('This trim data is unavailable');
      }

      return { Year: year, Make: make, Model: model, Trim: trim };
    },
    onError: (error: Error) => {
      showToast(error.message, {
        type: 'error',
      });
    },
  });
};
